export enum MilitaryStatusEnum
{
    ActiveDutyMilitary = 1,
    Veteran = 2,
    MilitarySpouse = 3,
    NotApplicable = 4
}